import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'

type UpdateIssueMilestoneBulkRequestBase = {
  ids: string[]
}

type UpdateIssueMilestoneBulkRequestWithMilestoneId = UpdateIssueMilestoneBulkRequestBase & {
  milestoneId: string
}

type UpdateIssueMilestoneBulkRequestWithClearMilestone = UpdateIssueMilestoneBulkRequestBase & {
  clearMilestone: true
}

export type UpdateIssueMilestoneBulkRequest =
  | UpdateIssueMilestoneBulkRequestWithMilestoneId
  | UpdateIssueMilestoneBulkRequestWithClearMilestone

export type UpdateIssueMilestoneBulkResponse = GraphQLResponse<UpdateIssuesBulkMutation>

export async function apiUpdateIssueMilestoneBulk(
  request: UpdateIssueMilestoneBulkRequest,
): Promise<UpdateIssueMilestoneBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {ids: request.ids, queryId: UpdateIssuesBulk}

  if ('milestoneId' in request) {
    body['milestoneId'] = request.milestoneId
  } else {
    body['clearMilestone'] = request.clearMilestone
  }
  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueMilestoneBulkResponse>
}
